// extracted by mini-css-extract-plugin
export default {"carousel":"home-module--carousel--gRGd-","banner":"home-module--banner--1RSLu","brands":"home-module--brands--15KqC","cta":"home-module--cta--2foi8"};